// @ts-nocheck
(function(){
  function toggle(e){
    var btn = e.target && e.target.closest && e.target.closest('.bento-cf-toggle');
    if(!btn) return;
    var targetId = btn.getAttribute('data-target');
    if(!targetId) return;
    var root = document.getElementById(targetId);
    if(!root) return;
    var pressed = btn.getAttribute('aria-pressed') === 'true';
    var next = !pressed;
    btn.setAttribute('aria-pressed', String(next));
    btn.setAttribute('aria-label', next ? 'Play' : 'Pause');
    if(next){
      // Paused state
      root.classList.add('is-paused');
    } else {
      // Playing state
      root.classList.remove('is-paused');
    }
  }

  function navigateSlide(e){
    var interactive = e.target && e.target.closest && e.target.closest('a, button, label, input, textarea, select, summary');
    if (interactive) return;

    var slides = e.target && e.target.closest && e.target.closest('.bento-crossfade-slides');
    if (!slides) return;

    var slideNodes = slides.querySelectorAll('.bento-crossfade-slide');
    var activeSlide = null;
    var maxOpacity = 0;

    for (var i = 0; i < slideNodes.length; i++) {
      var slide = slideNodes[i];
      var opacity = parseFloat(window.getComputedStyle(slide).opacity || '0');
      if (opacity >= maxOpacity) {
        maxOpacity = opacity;
        activeSlide = slide;
      }
    }

    if (!activeSlide || maxOpacity <= 0) return;

    var link = activeSlide.querySelector('.bento-card__link[href]');
    if (!link) return;

    window.location.href = link.href;
  }

  document.addEventListener('click', toggle);
  document.addEventListener('click', navigateSlide);
})(); 